<div class="sideBar">
  <div class="flex-row">
  
 
  <a href="/" class="logo p-4 d-block m-t-50">
    <img src="assets/images/apperion-logo.png" class="mw-100" />
   </a>
  </div>
  <div>
    <div *ngIf="scrollPoniter" class="mt-3">
      <div class="" style="max-width: 60%; margin: 0 auto;">
        <app-result-progress [outerStrokeColor]="'#fff'" [innerStrokeColor]="'#647e92'" [subtitleColor]="'#fff'"
          [titleColor]="'#fff'" [unitsColor]="'#fff'" [score]="score"></app-result-progress>
      </div>
      <p>YOUR {{categoryData[activeCat]?.name}} SCORE</p>


    </div>
    <p *ngIf="!scrollPoniter">Discover how you can achieve your Limitless Potential in life</p>
  </div>

</div>